import { useRoutes } from 'react-router-dom';
import useAuthRoutes from '../../hooks/Users/useAuthRoutes';
export default function AuthorizedRoutes() {
  const { authRoutes } = useAuthRoutes();

  const routes = useRoutes(authRoutes);

  return routes;
}
